import React, { useEffect } from 'react';
import { LandingPage } from './components/landing-page.jsx';
import { LpAgeGate } from './components/age-gate.jsx';

export default function App() {
  useEffect(() => {
    const onScroll = () => {
      document.querySelectorAll('.lp-nav').forEach((nav) => {
        nav.classList.toggle('is-stuck', window.scrollY > 24);
      });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <LpAgeGate />
      <main id="main">
        <LandingPage />
      </main>
    </>
  );
}
